module.exports = __webpack_public_path__ + "static/media/boy-13.de94bbff.svg";